import { datadogRum } from '@datadog/browser-rum';

import type { LogError } from './logError.types';

export const logError: LogError = async (message, context) => {
  datadogRum.addError(message, context);
};
